import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { AgGridModule } from "ag-grid-angular";
import { NgxSpinnerModule } from "ngx-spinner";

import {BadgeModule} from 'primeng/badge';
import {BreadcrumbModule} from 'primeng/breadcrumb';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card'
import {CalendarModule} from 'primeng/calendar';
import {ChartModule} from 'primeng/chart';
import {CheckboxModule} from 'primeng/checkbox';
import {ChipModule} from 'primeng/chip';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {DropdownModule} from 'primeng/dropdown';
import {FileUploadModule} from 'primeng/fileupload';
import {InputNumberModule} from 'primeng/inputnumber';
import {InputTextModule} from 'primeng/inputtext';
import {InputTextareaModule} from 'primeng/inputtextarea';
import {MenuModule} from 'primeng/menu';
import {MessagesModule} from 'primeng/messages';
import {MultiSelectModule} from 'primeng/multiselect';
import {TableModule} from 'primeng/table';
import {TabViewModule} from 'primeng/tabview';
import {ToastModule} from 'primeng/toast';
import {ToolbarModule} from 'primeng/toolbar';
import {TooltipModule} from 'primeng/tooltip';


import { AuthGuardService } from "../services/auth-guard.service";
import { ProjectFormComponent } from "./project-form.component";
import { ProjectInvoiceActionComponent } from "./project-invoice-action.component";
import { ProjectInvoiceHeaderComponent } from "./project-invoice-header.component";
import { ProjectInvoiceFormComponent } from "./project-invoice-form.component";
import { ProjectInvoiceListComponent } from "./project-invoice-list.component";
import { ProjectTimesheetComponent } from "./project-timesheet.component";
import { ProjectsComponent } from "./projects.component";
import { CommonModule } from "@angular/common";
import { OpenProjectComponent } from "./open-project.component";
import { HtmlTooltipComponent } from "./html-tooltip.component";
import { OpenProjectAddDialogComponent } from "./open-project-add-dialog.component";

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    AgGridModule,

    BadgeModule,
    BreadcrumbModule,
    ButtonModule,
    CalendarModule,
    CardModule,
    ChartModule,
    CheckboxModule,
    ChipModule,
    ConfirmDialogModule,
    DropdownModule,
    DynamicDialogModule,
    FileUploadModule,
    InputNumberModule,
    InputTextModule,
    InputTextareaModule,
    MenuModule,
    MessagesModule,
    MultiSelectModule,
    TableModule,
    TabViewModule,
    ToastModule,
    ToolbarModule,
    TooltipModule,

    RouterModule.forChild([
      {path: "projects", component: ProjectsComponent, canActivate: [AuthGuardService]},
      {path: "open-project", component: OpenProjectComponent, canActivate: [AuthGuardService]},
    ])
  ],
  declarations: [
    ProjectFormComponent,
    ProjectInvoiceActionComponent,
    ProjectInvoiceHeaderComponent,
    ProjectInvoiceFormComponent,
    ProjectInvoiceListComponent,
    ProjectTimesheetComponent,
    OpenProjectComponent,
    OpenProjectAddDialogComponent,
    HtmlTooltipComponent,
    ProjectsComponent
  ]
})
export class ProjectModule{}